<script>
import GenericTeaserCard from '@/components/cards/GenericTeaserCard.vue'

export default {
  name: 'Support',
  components: {
    GenericTeaserCard
  }
}
</script>

<template>
  <aside-container>
    <transition name="fade">
      <div class="view-spacing">
        <GenericTeaserCard
          :btn-text="$t('donationCard.btn')"
          :text="$t('donationCard.text')"
          :header-text="$t('donationCard.header')"
          action-link="https://www.wingsforlife.com/"
          image-src="/images/WheelchairRunning.png"
        />
        <GenericTeaserCard
          :btn-text="$t('missionCard.btn')"
          :text="$t('missionCard.text')"
          :header-text="$t('missionCard.header')"
          action-link="https://www.wingsforlife.com/"
          image-src="/images/WhyWeRun.png"
        />
      </div>
    </transition>
  </aside-container>
</template>
